import React, { Component } from "react"
import PropTypes from "prop-types"
import Fittty from "shared/components/fittty"

import classnames from "classnames"

import colors from "foundation/_colors.scss?variables"
import defaultCSS from "./connect_button.scss"
import smallFlavorCSS from "./small_connect_button.scss"

export default class ConnectButton extends Component {
  applyCSS = style => {
    return this.props.smallFlavor
      ? `smallFlavorCSS.${style}`
      : `defaultCSS.${style}`
  }

  render() {
    const knobBgColor = this.props.knobBgColor || {
      backgroundColor: `#${this.props.mainService.brand_color}`,
    }
    const connectCopy = this.props.programmable
      ? `Connect ${this.props.mainService.short_name}`
      : "Connect"
    const ctaCopy = this.props.connected ? "Connected" : connectCopy

    return (
      <div
        className="platform-preview"
        styleName={this.applyCSS("connect-button-outline")}
      >
        <div
          style={this.props.defaultBgColor}
          className="platform-preview"
          styleName={this.applyCSS("connect-button")}
          onClick={this.handleClick}
          data-track-ifttt-next-event="click"
          data-track-data={JSON.stringify({
            object_type: "connect_button",
            object_id: ctaCopy,
            location_type: "connection",
          })}
        >
          <div
            id="connect-ball"
            styleName={classnames({
              [this.applyCSS("service-icon")]: true,
              [this.applyCSS("alt-brand-color")]: this.props
                .knobBgColorForDarkBrands,
              [this.applyCSS("connected")]: this.props.connected,
            })}
            style={knobBgColor}
          >
            {this.props.programmable && (
              <img
                src={
                  this.props.mainService.lrg_monochrome_image_url ||
                  this.props.mainService.lrg_variant_image_url
                }
              />
            )}
          </div>
          <div
            styleName={classnames({
              [this.applyCSS("connect-cta")]: true,
              [this.applyCSS("connected")]: this.props.connected,
            })}
          >
            <div>
              <Fittty
                maxSize={this.props.connectButtonMaxFontSize}
                minSize={14}
                text={ctaCopy}
              />
            </div>
          </div>
        </div>
      </div>
    )
  }

  handleClick = event => {
    event.preventDefault()
    this.props.onConnectClick(event)
  }
}

ConnectButton.propTypes = {
  mainService: PropTypes.object.isRequired,
  onConnectClick: PropTypes.func.isRequired,
  connected: PropTypes.bool,
  programmable: PropTypes.bool,
  defaultBgColor: PropTypes.object,
  knobBgColor: PropTypes.object,
  knobBgColorForDarkBrands: PropTypes.bool,
  connectButtonMaxFontSize: PropTypes.number,
  smallFlavor: PropTypes.bool,
}

ConnectButton.defaultProps = {
  defaultBgColor: { backgroundColor: colors.primaryTextColor },
  connected: false,
  onConnectClick: () => {},
  connectButtonMaxFontSize: 30,
  smallFlavor: false,
}
